export default {
  ach_title: {
    id: 'buyback_merchant_update_ach_title',
    defaultMessage: 'ACH payment information',
  },
  ach_subtitle: {
    id: 'buyback_merchant_update_ach_subtitle',
    defaultMessage:
      'Please add your ACH payment information to purchase items through BuyBack',
  },
  ach_toastSuccessTitle: {
    id: 'buyback_merchant_toast_succes_title',
    defaultMessage: 'Well done!',
  },
  ach_toastSuccessContent: {
    id: 'buyback_merchant_toast_succes_content',
    defaultMessage: 'Your ACH info are correctly updated!',
  },
  ach_toastErrorTitle: {
    id: 'buyback_merchant_toast_error_title',
    defaultMessage: 'Oops!',
  },
  ach_toastErrorContent: {
    id: 'buyback_merchant_toast_error_content',
    defaultMessage: 'Something went wrong while updating your ACH info!',
  },
  ach_submitButtonLabel: {
    id: 'buyback_options_payment_by_Bank_transfer_CTA',
    defaultMessage: 'Add Bank details',
  },
  bacs_title: {
    id: 'buyback_merchant_update_bacs_title',
    defaultMessage: 'BACS payment information',
  },
  bacs_subtitle: {
    id: 'buyback_merchant_update_bacs_subtitle',
    defaultMessage:
      'Please add your BACS payment information to purchase items through BuyBack',
  },
  bacs_toastSuccessTitle: {
    id: 'buyback_merchant_toast_succes_title',
    defaultMessage: 'Well done!',
  },
  bacs_toastSuccessContent: {
    id: 'buyback_merchant_update_bacs_confirmation',
    defaultMessage:
      'Your payment information have been successfully submitted. It can take up to 6 days to be validated.',
  },
  bacs_toastErrorTitle: {
    id: 'buyback_error_toast_title',
    defaultMessage: 'Oh no!',
  },
  bacs_toastErrorContent: {
    id: 'buyback_error_toast_content',
    defaultMessage: 'Something went wrong. Try again later.',
  },
  bacs_submitButtonLabel: {
    id: 'buyback_options_payment_by_Bank_transfer_CTA',
    defaultMessage: 'Add Bank details',
  },
  card_title: {
    id: 'buyback_merchant_update_cc_form_title',
    defaultMessage: 'Credit of Debit Card',
  },
  card_subtitle: {
    id: 'credit_card_form_title',
    defaultMessage: 'Credit or debit card',
  },
  card_toastSuccessTitle: {
    id: 'buyback_merchant_update_cc_success_title',
    defaultMessage: 'Hurray! Card updated.',
  },
  card_toastSuccessContent: {
    id: 'buyback_merchant_update_cc_success_content',
    defaultMessage: 'Your card has been successfully updated.',
  },
  card_toastErrorTitle: {
    id: 'buyback_merchant_update_cc_failure_title',
    defaultMessage: 'Oops... Something went wrong.',
  },
  card_toastErrorContent: {
    id: 'buyback_merchant_update_cc_failure_content',
    defaultMessage: 'Please try to update your card again.',
  },
  card_submitButtonLabel: {
    id: 'buyback_options_payment_by_card_CTA',
    defaultMessage: 'Add card',
  },
  sepa_title: {
    id: 'buyback_merchant_update_sepa_form_title',
    defaultMessage: 'Setup your SEPA',
  },
  sepa_subtitle: {
    id: 'payement_blocks_sepa_title',
    defaultMessage: 'SEPA levy configuration',
  },
  sepa_toastSuccessTitle: {
    id: 'buyback_merchant_update_sepa_success_title',
    defaultMessage: 'Hurray! SEPA updated.',
  },
  sepa_toastSuccessContent: {
    id: 'buyback_merchant_update_sepa_success_content',
    defaultMessage: 'Your SEPA has been successfully updated.',
  },
  sepa_toastErrorTitle: {
    id: 'buyback_merchant_update_sepa_failure_title',
    defaultMessage: 'Oops... Something went wrong.',
  },
  sepa_toastErrorContent: {
    id: 'buyback_merchant_update_sepa_failure_content',
    defaultMessage: 'Please try to update your SEPA again.',
  },
  sepa_submitButtonLabel: {
    id: 'buyback_options_payment_by_Bank_transfer_CTA',
    defaultMessage: 'Add Bank details',
  },
}
